<div [class.modal-box]="!compon">
	<form (ngSubmit)="save()">
		<div class="modal-title" *ngIf="!compon">
			<span>Business Hours</span>
			<span class="modal-title__step">Step 2</span>
		</div>
		<button mat-icon-button type="button" class="modal-close" *ngIf="!compon" (click)="close()">
			<span class="modal-close__icon"></span>
		</button>

		<div class="hours">
			<div class="hours__day" *ngFor="let day of us.days_of_week" [class._empty]="!profile.data.business_hours[day]?.length">
				<div class="hours__day__name">{{day}}</div>
				<div class="hours__day__body">
					<ng-container *ngFor="let hour of profile.data.business_hours[day]; index as i; last as last">
						<div class="hours__day__body__item">
							<div class="hours__day__body__item-time">
								<timepicker 
									label="Start*" 
									[value]="hour.from" 
									(valueChange)="hour.from = $event; Change.emit(profile)" 
									[requiredText]="submitted&&!hour.from&&'Start is required' || i>0&&convertTimeToMinutes(hour.from)<=convertTimeToMinutes(profile.data.business_hours[day][i-1].to)&&'Time is overlapping'"
									[required]="submitted&&!hour.from || i>0&&convertTimeToMinutes(hour.from)<=convertTimeToMinutes(profile.data.business_hours[day][i-1].to)" 
								></timepicker>
								<timepicker 
									label="End*" 
									[value]="hour.to" 
									(valueChange)="hour.to = $event; Change.emit(profile)" 
									[requiredText]="submitted&&!hour.to&&'End is required' || !!profile.data.business_hours[day]?.[i+1]&&convertTimeToMinutes(hour.to)>=convertTimeToMinutes(profile.data.business_hours[day][i+1].from)&&'Time is overlapping' || convertTimeToMinutes(hour.to)<=convertTimeToMinutes(hour.from)&&'The end time must be after the start time'"
									[required]="submitted&&!hour.to || !!profile.data.business_hours[day]?.[i+1]&&convertTimeToMinutes(hour.to)>=convertTimeToMinutes(profile.data.business_hours[day][i+1].from) || convertTimeToMinutes(hour.to)<=convertTimeToMinutes(hour.from)" 
								></timepicker>
							</div>
							<div class="hours__day__body__item-actions" [class._last]="last">
								<button mat-icon-button color="warn" class="waw-btn__icon warn" type="button" (click)="profile.data.business_hours[day].splice(i, 1); Change.emit(profile)"><span class="material-icons-round notranslate">remove</span></button>
								<button *ngIf="last && profile.data.business_hours[day]?.length < 10" mat-icon-button color="primary" class="waw-btn__icon primary" type="button" (click)="addHour(day); Change.emit(profile)"><span class="material-icons-round notranslate">add</span></button>
							</div>
						</div>
					</ng-container>
					<ng-container *ngIf="!profile.data.business_hours[day]?.length">
						<button mat-icon-button color="primary" class="waw-btn__icon primary" type="button" (click)="addHour(day); Change.emit(profile)"><span class="material-icons-round notranslate">add</span></button>
					</ng-container>
				</div>
			</div>
		</div>

		<div class="modal-btn" *ngIf="!compon">
			<button mat-button color="primary" type="button" class="waw-btn _second" (click)="back();">Back</button>
			<button mat-flat-button color="primary" type="submit" class="waw-btn _primary">{{profile._id&&'Save'||'Create'}}</button>
		</div>
	</form>
</div>
